var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", { staticClass: "internal-page-banner-main col-12" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "page-title" }, [
            _c("h1", [
              _vm._v(" Wellness \n                        "),
              _vm.role.id <= 1
                ? _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-sm-12 col-md-2 col-lg-2 pull-right"
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          name: "locationId",
                          id: "locationData",
                          label: "text",
                          clearable: false,
                          searchable: false,
                          filterable: false,
                          options: _vm.locationArr,
                          placeholder: "Select State"
                        },
                        model: {
                          value: _vm.locationId,
                          callback: function($$v) {
                            _vm.locationId = $$v
                          },
                          expression: "locationId"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.role.id <= 1
                ? _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-sm-12 col-md-2 col-lg-2 pull-right"
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          name: "roleId",
                          id: "roleData",
                          label: "text",
                          clearable: false,
                          searchable: false,
                          filterable: false,
                          options: _vm.roleArr,
                          placeholder: "Select Role"
                        },
                        model: {
                          value: _vm.roleId,
                          callback: function($$v) {
                            _vm.roleId = $$v
                          },
                          expression: "roleId"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "internal-page-main-section wellness-section-main col-12"
      },
      [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "row" },
            [
              _c("app-slider", {
                key: _vm.sliderType.location_type,
                attrs: { sliderType: _vm.sliderType }
              }),
              _vm._v(" "),
              _vm._l(_vm.wellnessData, function(wellness, index) {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "wellness-main-section-h col-12 float-l",
                      attrs: { id: "wellness_" + wellness.id }
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "wellness-left-section col-12 col-sm-7 col-md-7 col-lg-7 float-l"
                          },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "wellness-right-img-box" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "wellness-left-text-box" },
                                    [
                                      _c(
                                        "h2",
                                        [
                                          wellness.title != ""
                                            ? [_vm._v(_vm._s(wellness.title))]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          wellness.second_title != ""
                                            ? _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      wellness.second_title
                                                    ) +
                                                    " "
                                                )
                                              ])
                                            : _vm._e()
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      wellness.tag_line != ""
                                        ? _c("p", [
                                            _vm._v(
                                              " " +
                                                _vm._s(wellness.tag_line) +
                                                " "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "view-btn-small-red btn-pd-top col-12"
                                        },
                                        [
                                          wellness.flyer != ""
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "hvr-sweep-to-right-red ucase",
                                                  attrs: {
                                                    href: "#",
                                                    id: "id" + index
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.getSignedUrlPath(
                                                        wellness.flyer
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(" View Flyer ")]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  wellness.image_link != ""
                                    ? [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: wellness.image_link,
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            wellness.image != ""
                                              ? _c("img", {
                                                  attrs: {
                                                    src: wellness.image,
                                                    alt: wellness.title
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    : [
                                        wellness.image != ""
                                          ? _c("img", {
                                              attrs: {
                                                src: wellness.image,
                                                alt: wellness.title
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                ],
                                2
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "wellness-right-section col-12 col-sm-5 col-md-5 col-lg-5 float-l"
                          },
                          [
                            _c("div", { staticClass: "row" }, [
                              wellness.description_title != ""
                                ? _c(
                                    "h3",
                                    {
                                      staticClass:
                                        "color-blue heading-text-24 line-height-28 font-text-bold-mont"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(wellness.description_title) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              wellness.description != ""
                                ? _c("p", {
                                    staticClass:
                                      "color-333333 heading-text-14 line-height-20 float-l width-full font-text-semi-medium-mont mt-40 right-top-wellness-text",
                                    domProps: {
                                      innerHTML: _vm._s(wellness.description)
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              wellness.website_link != ""
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "view-btn-small-big mt-45 col-12"
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "hvr-sweep-to-right-blue ucase",
                                            attrs: {
                                              href: wellness.website_link,
                                              target: "_blank"
                                            }
                                          },
                                          [_vm._v(" Visit Website ")]
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        )
                      ])
                    ]
                  )
                ]
              })
            ],
            2
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61c999d5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61c999d5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wellness.vue
// module id = null
// module chunks = 